/*
 * @Author: caiqin.xie
 * @since: 2023-06-28 17:12:46
 * @lastTime: 2023-11-13 17:36:57
 * @LastEditors: caiqin.xie
 * @message: 邮件反馈--表单组件
 */
import React, { useState, useRef, useImperativeHandle, forwardRef, useEffect } from "react";
import { Form, Input, Checkbox, Message, Button } from '@arco-design/web-react';
import FormType from "../FormType";
import PrivacyClause from "../PrivacyClause";
import UploadFile from "../UploadFile";
import styles from "../../index.module.scss";
import request from '@/common/request'
import { DOMAIN_API, PRIVACY } from '@/common/const'
import LazyMedia from "@/components/LazyMedia"
import { getSpan } from '@/common/splitLine'
interface IProps {
  ctry: string;
  words: Record<string, string>;
  data: Record<string, any>;
  loading: boolean;
  submit: (data: any) => void;
  setLoading: (loading: boolean) => void;
}
const FormItem = Form.Item;
const SubmitForm = forwardRef((props: IProps, ref) => {
  const { ctry, words, data, loading, submit, setLoading } = props;
  const gategoryList = data.gategory; // 类别
  const productList = data.productModel; // 产品
  const countryList = data.countryOrRegion; // 国家
  const [verificationCode, setVerificationCode] = useState(data); // 验证码
  const formRef = useRef<any>();
  const [fileName, setFileName] = useState(''); // 文件名
  const [fileList, setFileList] = useState([]); // 文件列表
  const [visible, setVisible] = React.useState(false); // 隐私条款弹窗是否可见
  const [captchaId, setCaptchaId] = useState<string>(data?.captchaId || ''); // 验证码id
  // 处理单选框
  const options = [words?.support_email_us_agree_to];
  const [valueOptions, setValueOptions] = useState([0, 1]);
  const [privacyList, setPrivacyList] = useState(''); // 隐私条款
  // 表单校验规则
  const formRule = {
    gateGory: [{ required: true, message: `${words?.support_email_us_select + ' ' + words?.support_email_us_category}` }],
    productModel: [{ required: true, message: `${words?.support_email_us_select + ' ' + words?.support_email_us_product_model}` }],
    countryOrRegion: [{ required: true, message: `${words?.support_email_us_select + ' ' + words?.support_email_us_country}` }],
    questionDescription: [{ required: true, message: `${words?.support_email_us_input + ' ' + words?.support_email_us_question_desc}` }],
    name: [{ required: true, message: `${words?.support_email_us_input + ' ' + words?.support_email_us_name}` }],
    telephone: [
      { required: false, message: `${words?.support_email_us_input + ' ' + words?.support_email_us_tel}` },
      {
        validator: (value: string | undefined, callback: (error?: any) => void) => {
          if (value && !/^1[3456789]\d{9}$/.test(value)) {
            callback(`${words?.support_email_us_tel_tips}`)
          }
        }
      }
    ],
    email: [
      { required: true, message: `${words?.support_email_us_input + ' ' + words?.support_email_us_email}` },
      { type: 'email', message: `${words?.support_email_us_email_tips}` }],
    code: [{ required: true, message: `${words?.support_email_us_input + ' ' + words?.support_email_us_code}` }],
    agree: [{ required: true, message: `${words?.support_email_us_select + ' ' + words?.support_email_us_agree}` }]
  }
  // 表单数据
  const inputList = [
    {
      name: 'selected',
      key: 'gateGory',
      placeHolder: `${words?.support_email_us_category}`,
      selectedListKey: gategoryList.map((option: any) => ({
        key: option.id,
        value: option.modelValue,
        label: option.modelValue
      })),
      rules: formRule.gateGory
    }, {
      name: 'selected',
      key: 'productModel',
      placeHolder: `${words?.support_email_us_product_model}`,
      selectedListKey: productList.map((option: any) => ({
        key: option.id,
        value: option.modelValue,
        label: option.modelValue
      })),
      rules: formRule.productModel
    },
    {
      name: 'input',
      key: 'sn',
      placeHolder: `${words?.support_email_us_sn}`,
      extra: (<a href={`/${ctry}/support/faq`}> <div className={styles['puprle-tips']}>{words?.support_benefit_view_device_SN} </div></a>)
    },
    {
      name: 'selected',
      key: 'countryOrRegion',
      placeHolder: `${words?.support_email_us_country}`,
      selectedListKey: countryList.map((option: any) => ({
        key: option.id,
        value: option.modelValue,
        label: option.modelValue
      })),
      rules: formRule.countryOrRegion
    },
    {
      name: 'input',
      key: 'questionDescription',
      placeHolder: `${words?.support_email_us_question_desc}`,
      rules: formRule.questionDescription
    }, {
      name: 'input',
      key: 'name',
      placeHolder: `${words?.support_email_us_name}`,
      rules: formRule.name
    }, {
      name: 'input',
      key: 'telephone',
      placeHolder: `${words?.support_email_us_tel}`,
      rules: formRule.telephone
    }, {
      name: 'input',
      key: 'email',
      placeHolder: `${words?.support_email_us_email}`,
      rules: formRule.email
    }
  ]

  // 获取隐私条款
  const getList = (ctry: string) => {
    request.post(`${DOMAIN_API}/o/official/content/getContentList`, {
      contentTypeId: PRIVACY,
      stationCode: ctry,
    })
    .then(res => {
      const records = res.data.data[0].detail
      setPrivacyList(records)
    })
    .catch(err => {
      console.log(err)
    })
  }

  // 刷新验证码
  const changeVerificationCode = () => {
    request.get(`${DOMAIN_API}/o/equityAllocation/getCaptcha?captchaId=${captchaId}`)
    .then(res => {
      setVerificationCode(res.data)
      setCaptchaId(res.data?.captchaId)
    })
  }

  // 重置表单
  const resetForm = () => {
    formRef.current.resetFields()
    setFileList([])
    setFileName('')
  }

  // 提交前校验
  const submitHandle = () => {
    formRef.current?.validate().then((values: any) => {
      console.log('values', values)
      setLoading(true)
      values.stationCode = ctry
      values.file = fileList[0]
      values.captchaId = captchaId
      submit(values)
    }).catch((err: string) => {
      console.log(err)
    })
  }

  //将子组件的方法 暴露给父组件
  useImperativeHandle(ref, () => ({
    resetForm,
    changeVerificationCode
  }))

  // 弹出隐私条款
  const privacyClauseShow = () => {
    getList(ctry)
    setVisible(true)
  }

  // 隐私条款同意
  const privacyClauseAgree = () => {
    setVisible(false)
    formRef.current.setFieldsValue({ agree: [0] })
  }

  return (
    <>
      <Form ref={formRef} autoComplete="off" layout="vertical" className={styles['contact-form']}>
        <FormType inputList={inputList} />
        {/* 下面无法整合 */}
        {/* 附件上传 */}
        <UploadFile words={words} setFileList={setFileList} fileName={fileName} setFileName={setFileName} />
        {/* 验证码 */}
        <div className={styles['verification-input']}>
          <FormItem label field='code' rules={formRule.code}>
            <Input placeholder={`${words?.support_email_us_code}`} />
            {/* Code */}
          </FormItem>
          <div className={styles["verification-code"]} onClick={changeVerificationCode}>
            <LazyMedia type="image" src={`data:image/png;base64,${verificationCode?.codeImg}`} alt="" />
          </div>
        </div>
        {/* 同意隐私条款 */}
        <div className={styles['contact-form-checkbox']}>
          <FormItem field='agree' rules={formRule.agree}>
            {/*<Checkbox>{words?.support_email_us_agree_to}</Checkbox>*/}
            {/* <Checkbox.Group
                value={valueOptions}
                options={options.map((x, i) => ({
                  label: getSpan(x),
                  value: i,
                }))}
            /> */}
            <Checkbox.Group value={valueOptions}>
              {options.map((item, index) => {
                return (
                  <Checkbox key={index} value={index}></Checkbox>
                )
              })}
            </Checkbox.Group>
          </FormItem>
          <div onClick={privacyClauseShow} className={styles['privacy_terms']}>{getSpan(options[0])}</div>
          {/* <span onClick={privacyClauseShow} className={styles['contact-form-privacy_terms']}> {words?.support_email_us_privacy_terms}</span> */}
        </div>
        <FormItem>
          <Button size="large" className={styles['contact-form-btn']} onClick={submitHandle} loading={loading}>{words?.common_submit}</Button>
          {/* Submit */}
        </FormItem>
      </Form>
      {/* 隐私条款弹出框 */}
      <PrivacyClause privacyList={privacyList} ctry={ctry} words={words} visible={visible} setVisible={setVisible} privacyClauseAgree={privacyClauseAgree} />
    </>
  )
})
export default SubmitForm;
